import React from 'react';
import { Modal, Input, Select, message } from 'antd';
import { OntologyNode } from '../hooks/useResourceTree';
import { RESOURCE_NAME_MAX_LENGTH } from '../constants/resource';

interface ActionModalsProps {
  // 重命名相关
  renameModalVisible: boolean;
  renameNodeData: OntologyNode | null;
  renameValue: string;
  setRenameValue: (value: string) => void;
  onRenameConfirm: () => void;
  onRenameCancel: () => void;

  // 移动相关
  moveModalVisible: boolean;
  moveNodeData: OntologyNode | null;
  targetDirectoryId: number | undefined;
  setTargetDirectoryId: (id: number | undefined) => void;
  moveDirectoryOptions: { label: string; value: number }[];
  deleteDirectoryOptions: { label: string; value: number }[];
  onMoveConfirm: () => void;
  onMoveCancel: () => void;

  // 删除相关
  deleteModalVisible: boolean;
  deleteNodeData: OntologyNode | null;
  onDeleteConfirm: () => void;
  onDeleteCancel: () => void;
}

export const ActionModals: React.FC<ActionModalsProps> = ({
  renameModalVisible,
  renameNodeData,
  renameValue,
  setRenameValue,
  onRenameConfirm,
  onRenameCancel,
  moveModalVisible,
  moveNodeData,
  targetDirectoryId,
  setTargetDirectoryId,
  moveDirectoryOptions,
  deleteDirectoryOptions,
  onMoveConfirm,
  onMoveCancel,
  deleteModalVisible,
  deleteNodeData,
  onDeleteConfirm,
  onDeleteCancel,
}) => {
  return (
    <>
      {/* 重命名弹窗 */}
      <Modal
        title="重命名"
        open={renameModalVisible}
        onOk={() => {
          if (renameNodeData) {
            onRenameConfirm();
          }
        }}
        onCancel={onRenameCancel}
        okText="确认"
        cancelText="取消"
      >
        <Input
          value={renameValue}
          onChange={e => setRenameValue(e.target.value)}
          placeholder="请输入新名称"
          maxLength={RESOURCE_NAME_MAX_LENGTH}
          onPressEnter={() => {
            if (renameNodeData) {
              onRenameConfirm();
            }
          }}
        />
      </Modal>

      {/* 移动弹窗 */}
      <Modal
        title="移动到"
        open={moveModalVisible}
        onOk={() => {
          if (
            moveNodeData &&
            moveNodeData.id &&
            targetDirectoryId !== undefined
          ) {
            onMoveConfirm();
          }
        }}
        onCancel={onMoveCancel}
        okText="确认"
        cancelText="取消"
      >
        <div className="mb-4">
          <span className="text-gray-600">
            将 "{moveNodeData?.title}" 移动到：
          </span>
        </div>
        <Select
          value={targetDirectoryId}
          onChange={setTargetDirectoryId}
          placeholder="选择目标目录"
          style={{ width: '100%' }}
          options={moveDirectoryOptions}
        />
      </Modal>

      {/* 删除确认弹窗 */}
      <Modal
        title="确认删除"
        open={deleteModalVisible}
        onOk={() => {
          if (deleteNodeData) {
            // 如果是目录且需要移动子资源，显示目标目录选择
            if (
              deleteNodeData.type === 'folder' &&
              deleteNodeData.children &&
              deleteNodeData.children.length > 0
            ) {
              // 检查是否选择了目标目录
              if (targetDirectoryId !== undefined) {
                onDeleteConfirm();
              } else {
                message.warning('请选择要移动子资源的目标目录');
              }
            } else {
              // 直接删除
              onDeleteConfirm();
            }
          }
        }}
        onCancel={onDeleteCancel}
        okText="确认删除"
        cancelText="取消"
        okButtonProps={{ danger: true }}
      >
        <div className="space-y-4">
          <p>确定要删除 "{deleteNodeData?.title}" 吗？</p>

          {deleteNodeData?.type === 'folder' &&
            deleteNodeData.children &&
            deleteNodeData.children.length > 0 && (
              <div>
                <p className="text-orange-600 mb-2">
                  该目录下还有其他资源，删除后这些资源将移动到：
                </p>
                <Select
                  value={targetDirectoryId}
                  onChange={setTargetDirectoryId}
                  placeholder="选择目标目录"
                  style={{ width: '100%' }}
                  options={deleteDirectoryOptions}
                />
              </div>
            )}
        </div>
      </Modal>
    </>
  );
};
